<template>
  <v-col :cols="12" :sm="12" :md="12">
    <v-autocomplete clearable label="Selecionar Unidade" :items="listaDeEnderecos" v-model="enderecoSelecionado"> </v-autocomplete>

    <Alertas :notificacaoSocket="alertaSocket" :texto="alerta.texto" :tipo="alerta.tipo"></Alertas>

    <DataTable
      v-show="showSkeletonTable == false && showDatatable"
      :tableTitle="'Dispensas de Pacientes'"
      :tableHeader="headers"
      :tableRows="listaDeDispensaPacientes"
      :isView="false"
      :isEdit="true"
      :isFinish="false"
      :isDevolucao="true"
      :isPrint="false"
      :totalItens="totalDispensa"
      v-on:datatable-updaterow="modalAtualizar"
      v-on:datatable-devolucao="modalDeletar"
      v-on:datatable-update-page="updatePage"
      v-on:datatable-update-search="updateSearch"
    ></DataTable>

    <SkeletonTable v-show="showSkeletonTable == false" :showSkeletonTable="showSkeletonTable"></SkeletonTable>

    <ModalCustomSize
      :modalSize="modalCustomSize.modalSize"
      :isTheModalOpen="modalCustomSize.isOpen"
      :modalButtonText="modalCustomSize.buttonText"
      :modalFormTitle="modalCustomSize.formTitle"
      :modalType="modalCustomSize.modalType"
      :isLoadingRequestDisable="modalCustomSize.isLoadingRequestDisable"
      :isModalButtonVisible="modalCustomSize.isButtonsVisible"
      :isModalButtonDisabled="modalCustomSize.isButtonsDisabled"
      v-on:formmodal-close="modalCustomSize.isOpen = false"
      v-on:formmodal-action="atualizar(modalCustomSize.actualEdit)"
    >
      <v-form v-model="isFormValid">
        <v-row>
          <v-col cols="12">
            <AlertasModal :tipo="alertaModal.tipo" :texto="alertaModal.texto"></AlertasModal>
          </v-col>

          <v-col cols="6">
            <v-text-field v-model="modalCustomSize.actualEdit.nomePaciente" label="Nome do Paciente" single-line readonly></v-text-field>
          </v-col>

          <v-col cols="6">
            <v-text-field v-model="modalCustomSize.actualEdit.cpfPaciente" label="CPF do Paciente" single-line readonly></v-text-field>
          </v-col>

          <v-expand-transition v-if="modalCustomSize.actualEdit.nomeResponsavel || modalCustomSize.actualEdit.cpfResponsavel || modalCustomSize.actualEdit.dataNascimentoResponsavel">
            <v-col cols="12">
              <v-row>
                <v-col cols="12">
                  <v-subheader>Informações do Responsável</v-subheader>
                  <v-divider />
                </v-col>

                <v-col cols="12">
                  <v-text-field v-model="modalCustomSize.actualEdit.nomeResponsavel" name="nomeResponsavelPaciente" label="Nome completo do Responsável" autocomplete="off" readonly></v-text-field>
                </v-col>

                <v-col cols="6">
                  <v-text-field v-model="modalCustomSize.actualEdit.cpfResponsavel" name="cpfResponsavelPaciente" label="CPF do Responsável" autocomplete="off" v-mask="['###.###.###-##']" @change="verificaCpf(modalCustomSize.actualEdit.cpfResponsavel)" readonly></v-text-field>
                </v-col>

                <v-col cols="6">
                  <v-text-field v-model="modalCustomSize.actualEdit.dataNascimentoResponsavel" name="dataNascimentoResponsavel" label="Data Nascimento do Responsável" autocomplete="off" readonly></v-text-field>
                </v-col>
              </v-row>
            </v-col>
          </v-expand-transition>

          <v-col cols="12">
            <v-card>
              <v-card-title>
                <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar" single-line></v-text-field>
              </v-card-title>

              <v-data-table v-if="!dispensaAntiga" :headers="headersItensDispensados" :search="search" :items="modalCustomSize.actualEdit.listaDeItensEnviados" disable-sort>
                <template v-slot:top>
                  <v-toolbar flat color="white">
                    <v-toolbar-title>Produtos Dispensados</v-toolbar-title>
                    <v-spacer></v-spacer>
                  </v-toolbar>
                </template>

                <template v-slot:[`item.validade`]="{ item }">
                  <v-chip :color="corValidade(item.validade)" dark>{{ item.validade }}</v-chip>
                </template>

                <template v-slot:[`item.item.validade`]="{ item }">
                  <v-chip :color="corValidade(item.item.validade)" dark>{{ item.item.validade }}</v-chip>
                </template>

                <template v-slot:[`item.itemDispensa.quantidadeDispensada`]="props">
                  <v-text-field style="max-width:250px" v-model="props.item.itemDispensa.quantidadeDispensada" :rules="[rules.required]" label="Quantidade para Dispensar" single-line @keypress="(event) => filter(event)"></v-text-field>
                </template>

                <template v-slot:[`item.actions`]="{ item }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon small @click="deletarItemDaLista(item)" v-bind="attrs" v-on="on">mdi-delete</v-icon>
                    </template>
                    <span>Excluir</span>
                  </v-tooltip>
                </template>
              </v-data-table>

              <DataTable v-if="dispensaAntiga" :tableTitle="'Produtos Dispensados para o paciente: ' + modalCustomSize.actualEdit.nomePaciente" :tableHeader="headersItensDispensadosAntigo" :tableRows="modalCustomSize.actualEdit.listaDeItensEnviados"></DataTable>
            </v-card>
          </v-col>
        </v-row>
      </v-form>

      <v-snackbar v-model="snackbar.habilitar" :timeout="3000" :color="snackbar.cor">
        {{ snackbar.texto }}

        <template v-slot:action="{ attrs }">
          <v-btn v-bind="attrs" text @click="snackbar.habilitar = false">
            Fechar
          </v-btn>
        </template>
      </v-snackbar>
    </ModalCustomSize>

    <Loading :open="loading.open"></Loading>

    <AlertaSnackbar :habilitar="alertaSnackbar.mostrar" :texto="alertaSnackbar.texto" :cor="alertaSnackbar.cor" v-on:snack-close="alertaSnackbar.mostrar = false" />

    <DeleteItemModal :showModalDelete="modalDelete.abrir" :textModalDelete="modalDelete.texto" :buttomTextModalDelete="'Devolver'" v-on:close-modal="modalDelete.abrir = false" v-on:on-response-modal-delete="deletar"></DeleteItemModal>
  </v-col>
</template>

<script>
import DataTable from "@/components/DataTable2.vue";
import axios from "../plugins/axios";
import store from "@/store/index";
import ModalCustomSize from "@/components/ModalCustomSize.vue";
import SkeletonTable from "../components/SkeletonTable";
import Alertas from "../components/Alertas.vue";
import AlertasModal from "../components/AlertasModal.vue";
import Loading from "../components/Loading.vue";
import DeleteItemModal from "../components/DeleteItemModal.vue";
import AlertaSnackbar from "../components/AlertaSnackbar.vue";

export default {
  components: {
    DataTable,
    ModalCustomSize,
    SkeletonTable,
    Alertas,
    Loading,
    DeleteItemModal,
    AlertasModal,
    AlertaSnackbar,
  },

  data: () => ({
    //Paginação
    pageDispensa: 1,
    searchDispensa: null,
    totalDispensa: null,
    //Fim da paginação
    alerta: {
      texto: "",
      tipo: "",
    },

    alertaSocket: {
      texto: "",
      tipo: "",
    },

    alertaModal: {
      texto: "",
      tipo: "",
    },

    alertaSnackbar: {
      mostrar: false,
      texto: null,
      cor: "red",
    },

    snackbar: {
      habilitar: false,
      cor: "",
      texto: "",
    },

    modalDelete: {
      abrir: false,
      texto: "Deseja realmente devolver essa Dispensa de Paciente?",
      actualEdit: {
        dispensaPacienteSelecionado: null,
        listaDeItens: [],
      },
    },

    rules: {
      required: (value) => !!value || "Requer o campo!",
    },

    newNotify: {
      isNewNotify: false,
      text: "",
    },

    erro: false,
    mensagemErro: "Erro",

    search: "",
    showDatatable: false,
    showSkeletonTable: true,
    showTextField: false,
    isFormValid: false,

    menuDataNascimentoResponsavel: null,
    dateFormattedResponsavel: null,
    dispensaAntiga: false,

    loading: {
      open: null,
    },

    headers: [
      {
        text: "ID",
        value: "dispensaPaciente.numeroDispensaPaciente",
      },
      {
        text: "Nome Paciente",
        value: "paciente.descricaoNome",
      },
      {
        text: "Nome Unidade",
        value: "endereco.nomeEndereco",
      },
      {
        text: "Responsável pela Dispensa",
        value: "funcionario.nomeFuncionario",
      },
      {
        text: "Data Dispensa",
        value: "dispensaPaciente.dataDispensa",
      },
      { text: "Ações", value: "actions", sortable: false },
    ],

    headersItensDispensados: [
      {
        text: "ID",
        value: "itemDispensa.numeroItemDispensaPaciente",
      },
      {
        text: "Lote",
        value: "item.lote",
      },
      {
        text: "Nome Produto",
        value: "itemSistema.nomeItemSistema",
      },
      {
        text: "Validade",
        value: "item.validade",
      },
      {
        text: "Qt. Atual",
        value: "itemUnidade.quantidadeEstoque",
      },
      {
        text: "Quantidade Dispensada",
        value: "itemDispensa.quantidadeDispensada",
      },
      { text: "Ações", value: "actions", sortable: false },
    ],

    headersItensDispensadosAntigo: [
      {
        text: "ID",
        value: "itemDispensa.numeroItemDispensaPaciente",
      },
      {
        text: "Lote",
        value: "item.lote",
      },
      {
        text: "Nome Produto",
        value: "itemSistema.nomeItemSistema",
      },
      {
        text: "Validade",
        value: "item.validade",
      },
      {
        text: "Quantidade Dispensada",
        value: "itemDispensa.quantidadeDispensada",
      },
    ],

    modalCustomSize: {
      modalSize: "1080",
      isOpen: false,
      buttonText: "",
      formTitle: "",
      isEdit: false,
      isButtonsVisible: true,
      isButtonsDisabled: false,
      isLoadingRequestDisable: false,
      actualEdit: {
        descricaoTela: "dispensaPacientes",
        numeroDispensaPaciente: null,
        numeroPaciente: null,
        numeroEndereco: null,
        nomeResponsavelUnidade: null,
        dataDispensa: null,
        numeroUnidade: null,
        nomePaciente: null,
        cpfPaciente: null,
        nomeResponsavel: null,
        cpfResponsavel: null,
        dataNascimentoResponsavel: null,
        quantidadeRecebidaItems: null,
        listaDeItensEnviados: [],
        listaDeItensExcluidos: [],
      },
    },

    config: {
      headers: {
        "Content-Type": "application/json",
        "x-auth-token": store.state.token,
      },
    },

    //Array populado pela função initialize
    listaDeEnderecos: [],
    listaDeDispensaPacientes: [],
    listaDeItensDispensaPacientes: [],

    enderecoSelecionado: null,
  }),

  created() {
    this.initialize();
  },

  watch: {
    enderecoSelecionado() {
      if (this.enderecoSelecionado) {
        this.modalCustomSize.actualEdit.numeroEndereco = this.enderecoSelecionado;
        this.showSkeletonTable = true;

        this.recoverInfos();
        this.showDatatable = true;
      } else {
        this.showSkeletonTable = false;
        this.showDatatable = false;
      }
    },

    isFormValid() {
      this.modalCustomSize.isButtonsDisabled = !this.isFormValid;
    },
  },

  methods: {
    async initialize() {
      try {
        let response = await axios.get("enderecoordemservico", this.config);
        this.listaDeEnderecos = response.data.map((row) => {
          return {
            value: row.numeroEnderecoOrdemServico,
            text: row.nomeEndereco,
          };
        });
      } catch (error) {
        console.log(error);
        this.alerta.texto = error.response.data.message;
        this.alerta.tipo = "erro";
      }
    },

    async recoverInfos() {
      try {
        await this.listarDispensaPacientes();
      } catch (error) {
        console.log(error);
      }
    },

    async listarDispensaPacientes() {
      try {
        let response = await axios.put("dispensaPaciente", { numeroEndereco: this.enderecoSelecionado, page: this.pageDispensa, search: this.searchDispensa }, this.config);
        if (!response.data || response.data.length > 0) {
          this.listaDeDispensaPacientes = response.data;
          this.totalDispensa = response.data[0].dispensaPaciente.total;
        }

        this.loading.open = false;
        this.showSkeletonTable = false;
      } catch (error) {
        console.log(error);
        this.showSkeletonTable = false;
        this.alerta.texto = error.response.data.message;
        this.alerta.tipo = "erro";
      }
    },

    async updateSearch(search) {
      if (search) {
        this.searchDispensa = search;
        this.pageDispensa = 1;
        await this.listarDispensaPacientes();
      } else {
        this.pageDispensa = 1;
      }
    },

    async updatePage(pagination) {
      this.pageDispensa = pagination.page;
      await this.listarDispensaPacientes();
    },

    async atualizar(dispensaPaciente) {
      try {
        await axios.put("atualizaDispensaPaciente", dispensaPaciente, this.config);

        this.alerta.texto = "Produto da Dispensa atualizado com sucesso!";
        this.alerta.tipo = "sucesso";
        this.modalCustomSize.isOpen = false;
      } catch (error) {
        console.log(error);
        this.alertaModal.texto = error.response.data.message;
        this.alertaModal.tipo = "erro";
        this.alertaSnackbar.texto = error.response.data.message;
        this.alertaSnackbar.mostrar = true;
      } finally {
        this.initialize();
      }
    },

    async deletar() {
      try {
        await axios.delete("dispensaPaciente", {
          data: this.modalDelete.actualEdit,
          headers: this.config.headers,
        });

        this.alerta.texto = "Dispensa Paciente removido com sucesso!";
        this.alerta.tipo = "sucesso";
        this.modalCustomSize.isLoadingRequestDisable = false;
      } catch (error) {
        console.log(error);
        this.alerta.texto = error.response.data.message;
        this.alerta.tipo = "erro";
      } finally {
        this.modalDelete.abrir = false;
        this.recoverInfos();
      }
    },

    deletarItemDaLista(value) {
      value.itemDispensa.quantidadeDispensada = null;
      this.modalCustomSize.actualEdit.listaDeItensExcluidos.push(this.modalCustomSize.actualEdit.listaDeItensEnviados.filter((item) => item.itemDispensa.numeroItemDispensaPaciente == value.itemDispensa.numeroItemDispensaPaciente)[0]);

      this.modalCustomSize.actualEdit.listaDeItensEnviados = this.modalCustomSize.actualEdit.listaDeItensEnviados.filter((item) => item.itemDispensa.numeroItemDispensaPaciente != value.itemDispensa.numeroItemDispensaPaciente);
    },

    async modalAtualizar(value) {
      this.loading = true;
      try {
        //LISTA OS ITENS DA DISPENSA DESSE PACIENTE
        const response = await axios.put("itensDispensadosPaciente", { numeroDispensaPaciente: value.dispensaPaciente.numeroDispensaPaciente }, this.config);
        this.modalCustomSize.actualEdit.listaDeItensEnviados = response.data;

        this.dispensaAntiga = true;
        response.data.map((itemSelecionado) => {
          if (itemSelecionado.itemUnidade) {
            this.dispensaAntiga = false;
          }
        });

        this.modalCustomSize.isButtonsVisible = !this.dispensaAntiga;

        this.search = "";
        this.itemSelecionado = null;
        this.setorSelecionado = value.numeroSetor;
        this.modalCustomSize.actualEdit.numeroPaciente = this.setorSelecionado;
        this.modalCustomSize.actualEdit.numeroDispensaPaciente = value.dispensaPaciente.numeroDispensaPaciente;
        this.modalCustomSize.actualEdit.numeroEndereco = this.enderecoSelecionado;
        this.modalCustomSize.actualEdit.nomeUnidade = value.endereco.nomeEndereco;
        this.modalCustomSize.actualEdit.nomeResponsavelUnidade = value.endereco.nomeResponsavel;

        this.modalCustomSize.actualEdit.nomePaciente = value.paciente.descricaoNome;
        this.modalCustomSize.actualEdit.cpfPaciente = value.paciente.descricaoCpf;
        this.modalCustomSize.actualEdit.nomeResponsavel = value.paciente.descricaoNomeResponsavel;
        this.modalCustomSize.actualEdit.cpfResponsavel = value.paciente.descricaoCpfResponsavel;
        this.modalCustomSize.actualEdit.dataNascimentoResponsavel = value.paciente.dataNascimentoResponsavel;

        this.modalCustomSize.actualEdit.dataDispensa = value.dispensaPaciente.dataDispensa;
        this.modalCustomSize.actualEdit.listaDeItensExcluidos = [];
      } catch (error) {
        console.log(error);
        this.alertaModal.texto = error.response.data.message;
        this.alertaModal.tipo = "erro";
        this.alertaSnackbar.texto = error.response.data.message;
        this.alertaSnackbar.mostrar = true;
      } finally {
        this.modalCustomSize.isEdit = true;
        this.modalCustomSize.isButtonsDisabled = !this.isFormValid;
        this.modalCustomSize.buttonText = "Concluir";
        this.modalCustomSize.formTitle = "Editar Dispensa do Paciente";
        this.modalCustomSize.isOpen = true;
        this.loading = false;
      }
    },

    async modalDeletar(dispensaPaciente) {
      const response = await axios.put("itensDispensadosPaciente", { numeroDispensaPaciente: dispensaPaciente.dispensaPaciente.numeroDispensaPaciente }, this.config);

      this.modalDelete.actualEdit.listaDeItens = response.data;
      this.modalDelete.actualEdit.dispensaPacienteSelecionado = dispensaPaciente;
      this.modalDelete.abrir = true;
    },

    //#region FORMATADORES
    corValidade(data) {
      if (data) {
        var ano = data.split("/")[2];
        var mes = data.split("/")[1];
        var dia = data.split("/")[0];
        // var dia2  = dia.substring(0,2)

        const dataFormatada = ano + "-" + ("0" + mes).slice(-2) + "-" + dia;

        const dias = this.verificarDias(dataFormatada);

        if (store.state.numeroEndereco == 127 || store.state.numeroEndereco == "127" || store.state.numeroEndereco == 124 || store.state.numeroEndereco == "124") {
          if (dias > 90) {
            return "green";
          } else if (dias > 0 && dias <= 90) {
            return "orange";
          } else if (dias <= 0) {
            return "red";
          }
        } else {
          if (dias > 30) {
            return "green";
          } else if (dias > 0 && dias <= 30) {
            return "orange";
          } else if (dias <= 0) {
            return "red";
          }
        }
      }
    },

    verificarDias(data) {
      const dateAtual = new Date().toISOString().substr(0, 10);
      const daterecive = data;

      const diferenceOfDates = new Date(daterecive) - new Date(dateAtual);
      const daysOfDiference = Math.ceil(diferenceOfDates / (1000 * 60 * 60 * 24));

      return daysOfDiference;
    },

    filter: function(evt) {
      evt = evt ? evt : window.event;
      let expect = evt.target.value.toString() + evt.key.toString();

      if (!/^[0-9]*?[0-9]*$/.test(expect)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    //#endregion
  },
};
</script>
